import React from "react";
import {
    Header, Segment, Button, Modal, Search, Checkbox, Label, Form
} from 'semantic-ui-react';
import Loader from "../../sharedComponent/loader/loader";
import NoResultFound from "../../sharedComponent/noResultFound"
import { Constants } from "../../../config/appConstants";

const CreateEmpGroupComponent = props => {
    return (

        <Segment.Group>
            <Segment className="stickyHeader">
                <Header as="h3" size='medium' textAlign='center'>{Constants.HEADING_FAVORITE_EMPLOYEE_GROUPS}</Header>
            </Segment>
            <Segment className="pb-5">
                <Form className="pb-2 root">
                    <Form.Input className='padding m-0 groupName'
                        fluid placeholder={Constants.PLACEHOLDER_ENTER_FAVORITES_NAME} value={props.createEmpGroup.grpName} onChange={props.handleChangeGrpName} />
                    <div className="overflowScroll accordionMenuHeight">
                        {props.createEmpGroup.alreadySelectedEmployees && props.createEmpGroup.alreadySelectedEmployees.filter(e => props.createEmpGroup.selectedEmployeeList.includes(Number(e.employeeID))).map((employee) => (
                            <Checkbox className="selectedRow empGroupSelected w-100" value={Number(employee.employeeID)} label={`${employee.employeeName} (${employee.employeeNumber})`}
                                // onChange={props.onEmployeeSelect}
                                // checked={props.createEmpGroup.selectedEmployeeList.includes(Number(employee.employeeID))}
                                checked
                            />
                        ))}
                        {props.createEmpGroup.employeeList && props.createEmpGroup.employeeList.filter(e => props.createEmpGroup.selectedEmployeeList.includes(e.id)).map((employee) => ( 
                            !props.createEmpGroup.alreadySelectedEmployees.find(ae => Number(ae.employeeID) === employee.id) &&
                            <Checkbox className="selectedRow empGroupSelected w-100" value={employee.id} label={`${employee.fullName} (${employee.employeeNumber})`}
                                // onChange={props.onEmployeeSelect}
                                // checked={props.createEmpGroup.selectedEmployeeList.includes(employee.id)}
                                checked
                            />
                        ))}
                    </div>
                    <Label color='orange' className='padding w-100 m-0 borderRadiusNone'>Others</Label>
                    <Search className='padding' onSearchChange={props.onSearch} value={props.createEmpGroup.searchText} placeholder="Search Employee's" />
                    <div className="mainContentRoot">

                        {/* Note :Bug#277 In Add Employee Team, the selected Employee in the List should not show in the Top (Inconsistence in Mobile & Web)
                          TO Revert this Bug Uncomment the below codes (line 43-54) and remove last unCommented one (line 56-60).. 
                         
                        {props.createEmpGroup.allEmployeeList && props.createEmpGroup.allEmployeeList.filter(e => props.createEmpGroup.selectedEmployeeList.includes(e.id)).map((employee) => (
                            <Checkbox className="selectedRow empGroupSelected w-100" value={employee.id} label={`${employee.fullName} (${employee.employeeNumber})`}
                                onChange={props.onEmployeeSelect}
                                checked={true}
                            />
                        ))}
                        {props.createEmpGroup.allEmployeeList && props.createEmpGroup.allEmployeeList.filter(e => !props.createEmpGroup.selectedEmployeeList.includes(e.id)).map((employee) => (
                            <Checkbox className="selectedRow w-100" value={employee.id} label={`${employee.fullName} (${employee.employeeNumber})`}
                                onChange={props.onEmployeeSelect}
                                checked={false}
                            />
                        ))} */}

                        {props.createEmpGroup.allEmployeeList && props.createEmpGroup.allEmployeeList.map((employee) => (
                            <Checkbox className="selectedRow empGroupSelected w-100" value={employee.id} label={`${employee.fullName} (${employee.employeeNumber})`}
                                onChange={props.onEmployeeSelect}
                                checked={props.createEmpGroup.selectedEmployeeList && props.createEmpGroup.selectedEmployeeList.includes(employee.id)}
                            />
                        ))}
                        {(props.createEmpGroup.allEmployeeList.length === 0) &&
                            <NoResultFound displayMessage={"No Employee Found"} />
                        }
                    </div>
                </Form>
            </Segment>
            <Segment>
                <div className='d-flex align-items justify-content-between btnFooter'>
                    <Button secondary onClick={props.onClickBack} className="borderRadius w-10" size='small'>
                        Back</Button>
                    {props.createEmpGroup.groupId > 0 &&
                        <Button secondary onClick={props.onClickDelete} className="borderRadius w-20" size='small'>
                            {Constants.DELETE_FAVORITES}  </Button>
                    }
                    <Button secondary className="borderRadius w-10" size='small' onClick={props.onClickSave}>
                        Save</Button>
                </div>
            </Segment>


            {/* Confirmation popup */}
            <Modal
                open={props.createEmpGroup.isShowSaveConfirmation}
                closeOnDimmerClick={false}
                size='tiny'
            >
                <Modal.Header className="text-center">Confirmation</Modal.Header>
                <Modal.Content >
                    Do you want to save changes?
                </Modal.Content>
                <Modal.Actions className="d-flex justify-content-between">
                    <Button secondary className="borderRadius w-25 ml-0" size='small' onClick={props.onCloseModel}>
                        No
                    </Button>
                    <Button secondary className="borderRadius w-25 mr-0" size='small' onClick={props.onClickSave}>
                        Yes
                    </Button>
                </Modal.Actions>
                {props.createEmpGroup.isShowLoader &&
                    <Loader />
                }
            </Modal>

            {/* Delete Timecard Popup */}
            {props.createEmpGroup.isDeleteConfirmationPopupVisible &&
                <Modal
                    open={props.createEmpGroup.isDeleteConfirmationPopupVisible}
                    closeOnDimmerClick={false}
                    size='tiny'
                >
                    <Modal.Header className="text-center">{Constants.DELETE_FAVORITES}</Modal.Header>
                    <Modal.Content scrolling style={{ minHeight: "auto" }}>
                        <p>{Constants.CONFIRMATION_DELETED_MESSAGE}</p>
                    </Modal.Content>
                    <Modal.Actions className="d-flex justify-content-between">
                        <Button onClick={props.onCancelClickInConfirmationPopup} secondary className="borderRadius w-25" size='small'>
                            Cancel  </Button>
                        <Button onClick={props.onDeleteClickInConfirmationPopup} secondary className="borderRadius w-25" size='small'>
                            Delete  </Button>
                    </Modal.Actions>
                    {props.createEmpGroup.isShowLoader &&
                        <Loader />
                    }
                </Modal>
            }
            {props.createEmpGroup.isShowLoader &&
                <Loader />
            }
        </Segment.Group>

    );
}

export default CreateEmpGroupComponent;

CreateEmpGroupComponent.displayName = "CreateEmpGroupComponent";